//配置信息
//const url = 'http://172.16.0.217:81/tusjf-cloud-gateway'
/* const url = 'https://gongan-web.tusjf.com/tusjf-cloud-gateway' */
// const url = 'https://szhz-web.tusjf.com/tusjf-cloud-gateway'
const url = 'https://tusjkweb.tusjf.com/tusjf-cloud-gateway'
export default{
	webUrl:url,
	staticUrl:url+'/sys/common/static'
}
